import fetchHandler, { fetchHandlerForm } from './Handler';

// import { Category } from '../../types/cards';

export const addIcon = async (body: FormData): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: '/ottapp/create',
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllICon = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: '/ottapp/', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const getSingleIcon = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `/ottapp/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error while fetching :', error);
		throw new Error('Could not fetch the data. Please try again later.');
	}
};

export const deleteIcon = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `/ottapp/${data}`,
		});
		// if (response) {
		// return await getAllProducts();
		// }
		return response;
	} catch (error) {
		console.error('Error while fetching :', error);
		throw new Error('Could not fetch the data. Please try again later.');
	}
};

// =======================================================
export const updateIcon = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `/ottapp/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error while fetching :', error);
		throw new Error('Could not fetch the data. Please try again later.');
	}
};
